import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPin, Briefcase, LifeBuoy, Receipt, Headset } from 'lucide-react';
import { RevealContact } from '../RevealContact';
import { Support247Button } from './Support247Button';
import { RAQ_CONTACTS } from '../../lib/contacts';

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-800">
      <Support247Button />

      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img src="/logo-white.png" alt="RAQ Technologies" className="h-12 w-auto" />
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Votre équipe d&apos;experts pour vos projets d&apos;affichage numérique depuis 2014.
            </p>
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <MapPin className="h-4 w-4" />
              <span>Québec, Canada</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/rental" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('nav.rental')}
                </Link>
              </li>
              <li>
                <Link to="/sales" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('nav.sales')}
                </Link>
              </li>
              <li>
                <Link to="/parts" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('nav.parts')}
                </Link>
              </li>
              <li>
                <Link to="/software" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('nav.software')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('nav.services')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-white mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/soumission" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Demande de soumission
                </Link>
              </li>
              <li>
                <Link to="/realizations" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('nav.realizations')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('nav.contact')}
                </Link>
              </li>
              <li>
                <span className="text-gray-400 text-sm">Support Technique 24/7</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-white mb-4">Contact</h3>
            <ul className="space-y-3">
              <li>
                <RevealContact variant="dark" type="phone" label="le numéro" value={RAQ_CONTACTS.phone} testId="footer-phone" />
              </li>
              <li>
                <RevealContact variant="dark" type="email" label="ventes" value={RAQ_CONTACTS.emails.sales} icon={Briefcase} testId="footer-sales" />
              </li>
              <li>
                <RevealContact variant="dark" type="email" label="support" value={RAQ_CONTACTS.emails.support} icon={LifeBuoy} testId="footer-support" />
              </li>
              <li>
                <RevealContact variant="dark" type="email" label="comptabilité" value={RAQ_CONTACTS.emails.accounting} icon={Receipt} testId="footer-accounting" />
              </li>
              <li>
                <RevealContact variant="dark" type="email" label="service client" value={RAQ_CONTACTS.emails.customerService} icon={Headset} testId="footer-customer-service" />
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} RAQ Technologies. {t('footer.rights')}.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-gray-500 hover:text-white text-sm transition-colors">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-white text-sm transition-colors">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
